module.exports = __webpack_public_path__ + "static/media/madfit-12.0646c34f.jpg";